exports = module.exports = require("./../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#intercom-container{display:none}.setupheader{top:0;display:-webkit-box;display:-moz-flex;display:-ms-flexbox;display:flex;-webkit-box-direction:normal;-webkit-box-orient:vertical;-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;-moz-justify-content:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;-moz-align-items:center;align-items:center;height:6rem;width:100%;margin-top:2rem}@media (max-width:599px){.setupheader{margin-top:1rem}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?localIdentName=[local]--[hash:base64:8]!./~/sass-loader!./src/components/setup/SetupHeader/styles.scss
// module id = 1012
// module chunks = 0